import React from 'react'
import injectStyles from 'react-jss'
import classNames from 'classnames'

const styles = {
  th: {
    padding: '22px 28px',
    overflow: 'hidden',
    whiteSpace: 'normal',
    wordBreak: 'break-all',
    textAlign: 'center',
    hyphens: 'auto',
    paddingRight: 14,
    paddingLeft: 14,
  },
}

const Th = ({ classes, children, className, ...otherProps }) => (
  <th {...otherProps} className={classNames(classes.th, className)}>
    {children}
  </th>
)

export default injectStyles(styles)(Th)



// WEBPACK FOOTER //
// ./src/Components/Stats/Table/Th.js